const IGNORED_SCHEMES = new Set(["tel", "mailto", "javascript", "sms", "blob", "data"]);

function isApplicationPath(pathname: string): boolean {
  return pathname === "/application" || pathname.startsWith("/application/");
}

function hasIgnoredScheme(href: string): boolean {
  const colonIndex = href.indexOf(":");
  if (colonIndex <= 0) return false;
  return IGNORED_SCHEMES.has(href.slice(0, colonIndex).toLowerCase());
}

export function getInAppLeavePath(href: string | null | undefined, currentPathname: string): string | null {
  if (!href) return null;

  const trimmed = href.trim();
  if (!trimmed || trimmed.startsWith("#")) return null;
  if (hasIgnoredScheme(trimmed)) return null;

  const origin = globalThis.location?.origin || "http://localhost";
  let url: URL;
  try {
    url = new URL(trimmed, origin);
  } catch {
    return null;
  }

  if (url.origin !== origin) return null;
  if (!isApplicationPath(currentPathname)) return null;

  const nextPath = url.pathname || "/";
  if (isApplicationPath(nextPath)) return null;

  return `${nextPath}${url.search}`;
}
